import React, { useState, useEffect } from 'react';
import ErpTemplate from '../../../components/ErpTemplate';
import { FaSave, FaBackward, FaThumbsUp, FaThumbsDown, FaPlaneDeparture, FaPlaneArrival } from 'react-icons/fa';
import api from '../../../services/api';
import { useHistory, useLocation } from 'react-router-dom';
import { dataMysql, extract } from '../../../util/util';
import ReactSelect from '../../../components/ReactSelect';
import NavItem from '../../../components/NavItem';
import InputMask from 'react-input-mask';
import { toast } from 'react-toastify';
import moment from 'moment';
import { getText, getParticipantLanguage } from '../../../util/translations';

export default function CadastroEventoParticipanteTransferConvite({ match }) {
    const id = match.params.id;
    const token = localStorage.getItem('token');
    const perfil = localStorage.getItem("perfil");
    const [dados, setDados] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [isError, setIsError] = useState(false);
    const history = useHistory();
    let { state } = useLocation();
    //var idEvento = state?.evento ?? null;
    const idioma = dados?.idioma || state?.idioma || null;

    const buscar = () => {
        setIsLoading(true);
        setIsError(false);
        api({
            method: "get",
            action: '/participante/' + id,
            token: token,
        }).then(response => {
            //extrai dados internos para o array principal
            var dadosRecebidos = extract({
                jsonLaravel: response.data.data,
                chaves: [
                    'enderecopais',
                    'aereomunicipioembarque',
                    'enderecomunicipio',
                    'banco',
                ]
            });

            //se estiver em alguma situação do grupo "confirmado" ou "declinaram", mostrar concluído
            var gruposSituacao = dadosRecebidos.grupoSituacao ?? [];
            if (gruposSituacao.includes("confirmados") || gruposSituacao.includes("declinaram")) {
                history.push({
                    pathname: "/cadastroEventoParticipanteConviteConcluido/" + dadosRecebidos.evento.id,
                    state: { idioma: dadosRecebidos.idioma }
                });
                return;
            }

            setDados(dadosRecebidos);
            setIsLoading(false);
        }).catch(err => {
            setIsLoading(false);
            setIsError(true);
            const message = idioma
                ? `${getText('error', idioma)} ${getText('errorLoadingDefault', idioma)}`
                : <>{getText('error', 'portugues')} {getText('errorLoadingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
            toast.error(message);
        });
    };//buscar

    const validar = () => {
        return true;
    };

    const salvar = () => {
        var idEvento = dados.evento.id;

        if (!validar()) {
            return false;
        }

        setIsSubmitting(true);

        api({
            method: 'put',
            action: '/participante/escolhaTransfer/' + id,
            token: token,
            data: {
                transferextra: (dados.transferextraobservacao ?? '') === '' ? 'nao' : 'sim',
                transferextraobservacao: dados.transferextraobservacao ?? null,
                transferobservacao: dados.transferobservacao ?? null,
            }
        })
            .then(function (response) {
                if (dados.hotelhospedagem === 'sim') {
                    history.push("/cadastroEventoParticipanteHotelConvite/" + id, { idioma: idioma });
                    return;
                }
                history.push("/cadastroEventoParticipanteConviteConcluido/" + idEvento, { idioma: idioma });
            })
            .catch(function () {
                const message = idioma
                    ? `${getText('error', idioma)} ${getText('errorSavingDefault', idioma)}`
                    : <>{getText('error', 'portugues')} {getText('errorSavingDefault', 'portugues')}<br />({getText('error', 'ingles')} {getText('errorLoadingDefault', 'ingles')})</>;
                toast.error(message);
            })
            .finally(() => {
                setIsSubmitting(false);
            });
    }; //salvar

    useEffect(() => { //onload
        buscar();
    },
        // eslint-disable-next-line
        []);

    return (
        <ErpTemplate sidebar={['listarsvp', 'cliente'].includes(perfil) ? false : true} processando={isLoading} idioma={idioma ?? "both"}>
            <div className="main-content container-fluid">
                <div className="page-title">
                    <h3>{getText('transfer', idioma)}</h3>
                </div>
                <section id="multiple-column-form">
                    <div className="row match-height">
                        <div className="col-sm-12">
                            {!isLoading && !isError && dados?.evento?.id && <form className="form" onSubmit={(e) => { salvar(); e.preventDefault(); }}>
                                <div className="card">
                                    <div className="card-content">
                                        {(dados.transferextra ?? "nao") === 'sim' ?
                                            <div className="card-body">
                                                <p><strong>{getText('transferExtra', idioma)} </strong>{getText('transferExtraDescricao', idioma)}</p>
                                                <p>{getText('dataHorarioTransfer', idioma)}</p>
                                                {!['chiesi'].includes((dados.evento?.cliente?.modelo ?? "master")) ?
                                                    <>
                                                        <p>{getText('informarEndereco', idioma)}</p>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <textarea
                                                                        className="form-control form-control-lg"
                                                                        id="transferextraobservacao"
                                                                        placeholder={getText('enderecoPlaceholder', idioma)}
                                                                        style={{ minHeight: "100px" }}
                                                                        value={dados.transferextraobservacao}
                                                                        onChange={e => setDados({ ...dados, ...{ "transferextraobservacao": e.target.value } })}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </> : null}
                                            </div> : null}
                                        {(dados.transfer ?? "nao") === 'sim' ?
                                            <div className="card-body">
                                                <p><strong>{getText('transferDescricao', idioma)} </strong>{getText('transferDescricaoCompleta', idioma)}</p>
                                                {!['chiesi'].includes((dados.evento?.cliente?.modelo ?? "master")) ?
                                                    <>
                                                        <p>{getText('naoUtilizarTransfer', idioma)}</p>
                                                        <div className="row">
                                                            <div className="col-sm-12">
                                                                <div className="form-group">
                                                                    <textarea
                                                                        className="form-control form-control-lg"
                                                                        id="transferobservacao"
                                                                        placeholder={getText('observacaoPlaceholder', idioma)}
                                                                        style={{ minHeight: "100px" }}
                                                                        value={dados.transferobservacao}
                                                                        onChange={e => setDados({ ...dados, ...{ "transferobservacao": e.target.value } })}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </> : null}
                                            </div> : null}
                                        <div className="card-body">
                                            <h4>{getText('informacoesImportantesTransfer', idioma)}</h4>
                                            <p>{getText('servicoExclusivo', idioma)} {dados.tipoparticipante === 1 ? getText('medico', idioma) : getText('convidado', idioma)} {getText('patrocinado', idioma)}</p>
                                            <p>{getText('alterarVoo', idioma)} {dados.tipoparticipante === 1 ? getText('medico', idioma) : getText('convidado', idioma)} {getText('patrocinado', idioma)}.<br />
                                                {getText('alteracoesAtrasos', idioma)}</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="card">
                                    <div className="card-content">
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-sm-12 d-flex justify-content-end">
                                                    <button type="submit" className="btn btn-primary me-1 mb-1" disabled={isSubmitting}>
                                                        <FaSave size={20} /> {getText('salvar', idioma)}</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </form>}
                        </div>
                    </div>
                </section>
            </div >
        </ErpTemplate >
    );
}